<template>
    <div class="selectcustomer" ref="back">
        <div class="selectcustomer__box" ref="box" v-if="!selectSede">
            <div class="selectcustomer__box-title">{{ $t('common.modal.customer.title') }}</div>
            <!-- ricerca -->
            <form class="selectcustomer__box-form form search" @submit.prevent="submitSearch">
                <div class="form__field">
                    <input type="text" class="form__field-input" v-model.trim="searchText"/>
                </div>
                <button type="submit" class="search__btn" :disabled="loading">
                    <span v-if="loading" class="loading">
                        <!-- {{ $t('common.loading') }} -->
                        <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                    </span>
                    <span v-if="!loading" class="start-search">
                        <!-- {{ $t('common.search') }} -->
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23"><path d="M23.008 21.952l-1.047 1.047-7.356-7.357c-3.492 2.958-8.723 2.796-12.016-.497A8.886 8.886 0 0115.154 2.579c3.294 3.293 3.455 8.525.498 12.016l7.356 7.357zM14.107 3.626A7.405 7.405 0 103.636 14.099 7.405 7.405 0 0014.107 3.626z"/></svg>
                    </span>
                </button>
                <span class="reset">
                    <button type="button" class="btn light" v-if="isFiltered"  @click="clearSearch()" :disabled="loading">Reset</button>
                </span>
            </form>
            <!-- tabella clienti -->
            <div class="selectcustomer__box-list clients-list" v-if="items">
                <div class="clients-list__box">
                    <div class="clients-list__item" v-for="customer in (items.data)" @click="select(customer)" v-bind:class="{ selected: customerSelected && (customer.id == customerSelected.id) }">
                        <strong>{{ customer.agency }}</strong>
                        {{ customer.first_name }} {{ customer.last_name }}
                        <small class="customer_last_update">
                            {{ $t('customers.last_update') }} {{ customer.updated_at | formatDateTime }}
                        </small>
                    </div>
                </div>
            </div>
            <!-- paginazione -->
            <div class="pagination" v-if="items && items.pages">
                <button class="btn-page" :disabled="page == 1" @click="firstPage()"><i class="fa fa-chevron-left"></i><i class="fa fa-chevron-left"></i></button>
                <button class="btn-page" :disabled="page == 1" @click="prevPage()"><i class="fa fa-chevron-left"></i></button>
                <button class="btn-page" v-bind:class="{'current-page': p == page}" v-for="p in buildPageArray(7)" @click="goPage(p)">
                    {{ p }}
                </button>
                <button class="btn-page" :disabled="page == items.pages" @click="nextPage()"><i class="fa fa-chevron-right"></i></button>
                <button class="btn-page" :disabled="page == items.pages" @click="lastPage()"><i class="fa fa-chevron-right"></i><i class="fa fa-chevron-right"></i></button>
            </div>
            <div class="controls__btns">
                <button type="button" class="btn btn__danger" @click="close()">{{ $t('common.abort') }}</button>
                <button type="button" class="btn" :disabled="customerSelected == null" @click="confirm()">{{ $t('common.select') }}</button>
            </div>
        </div>
        <div class="selectcustomer__box" ref="box" v-if="selectSede">
            <div class="selectcustomer__box-title">Seleziona una sede per <strong>{{ customerSelected.agency }}</strong></div>
            <div @click="confirmWithSede(s.indirizzo, s.luogo)" class="btn_select_sede" v-for="s in selectSediData">
                {{ s.indirizzo }} a {{ s.luogo }}
            </div>
        </div>
    </div>
</template>
<script>
    import { gsap } from 'gsap';
    export default {
        name: 'select-customer',
        props: {
            value: {
                required: true
            }
        },
        data() {
            return {
                loading: false,
                page: 1,
                pageSize: 15,
                searchText: '',
                items: null,
                customerSelected: null,
                isFiltered: false,
                selectSede: false,
                selectSediData: []
            }
        },
        watch: {
            value(v) {
                let modal = this.$refs;
                if (v) {
                    this.updateData();

                    gsap.timeline()
                        .to(modal.back, 0.3, { opacity: 1, pointerEvents: 'all'})
                        .to(modal.box, 0.4, { opacity: 1, y: 0 })

                } else {
                    gsap.timeline()
                        .to(modal.box, 0.4, { opacity: 0, y: 60 })
                        .to(modal.back, 0.3, { opacity: 0, pointerEvents: 'none'})
                }
            }
        },
        methods: {
            updateData() {
                this.loading = true;
                this.api.customers.offline.get(this.page, this.pageSize, this.searchText)
                    .then((data) => {
                        this.items = data;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
            },
            nextPage() {
                if (this.page < this.items.pages) {
                    this.page += 1;
                    this.updateData();
                }
            },
            prevPage() {
                if (this.page > 1) {
                    this.page -= 1;
                    this.updateData();
                }
            },
            firstPage() {
                this.page = 1;
                this.updateData();
            },
            lastPage() {
                this.page = this.items.pages || 1
                this.updateData();
            },
            goPage(page) {
                this.page = page;
                this.updateData();
            },
            close() {
                this.customerSelected = null;
                this.$emit("result", false);
                this.$emit("input", !this.value);
            },
            confirm() {
                this.selectSediData = [];
                this.selectSede = false;

                let a = {...this.customerSelected};
                a.sedi = a.sedi || "[]";
                try {
                    a.sedi = JSON.parse(a.sedi)
                } catch(e) {
                    a.sedi = [];
                }
                if(a.sedi && a.sedi.length == 0) {
                    a.sedi = {
                        'indirizzo': '',
                        'luogo': ''
                    };
                    this.$emit("result", a);
                    this.$emit("input", !this.value);
                }
                if(a.sedi && a.sedi.length == 1) {
                    a.sedi = a.sedi.pop()
                    this.$emit("result", a);
                    this.$emit("input", !this.value);
                }

                if(a.sedi && a.sedi.length > 1) {
                    this.selectSediData = a.sedi;
                    this.selectSede = true;
                }
            },
            confirmWithSede(indirizzo, luogo) {
                let a = {...this.customerSelected};
                a.sedi = {
                    indirizzo: indirizzo,
                    luogo: luogo
                };
                this.selectSediData = [];
                this.selectSede = false;
                this.$emit("result", a);
                this.$emit("input", !this.value);
            },
            select(customer) {
                if (this.customerSelected !== null && customer.id == this.customerSelected.id) {
                    this.customerSelected = null;
                } else {
                    this.customerSelected = customer;
                }
            },
            buildPageArray(num) {
                let start = 1;
                if (this.items.page > Math.round(num / 2)) {
                    start = this.items.page - Math.floor(num / 2);
                }
                let end = this.items.pages;
                if (this.items.page < (this.items.pages - Math.floor(num / 2))) {
                    end = this.items.page + Math.floor(num / 2);
                }
                let result = [];
                for (let i = start; i <= end; i++) {
                    result.push(i);
                }
                return result;
            },
            submitSearch() {
                this.searchText = this.searchText.trim();
                this.isFiltered = false;
                if(this.searchText != "") {
                    this.isFiltered = true;
                }
                this.updateData();
            },
            clearSearch() {
                this.searchText = "";
                this.isFiltered = false;
                this.updateData();
            }
        },
    };
</script>
<style lang="scss">
    @import './src/scss/variables';
    @import './src/scss/selectcustomer';

    .customer_last_update {
        width: 100% !important;
        padding-top: 5px;
        color: #888888;
    }

    .btn_select_sede {
        text-align: center;
        border: 1px solid $gray;
        margin: 10px 20%;
        padding: 20px;
        background: $light-green;
        color: $white;
        font-size: 20px;
    }
</style>
